import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';

export const filterDataByPredicates = <T, F>(
    data: Array<T>,
    filters: F,
    createPredicates: (filters: F) => FilterPredicate<T>[],
): Array<T> => {
    const activePredicates = createPredicates(filters)
        .filter(predicate => predicate.isActive());
    return data.filter(row => activePredicates.every(predicate => predicate.check(row)));
};
